export default __webpack_public_path__ + "static/media/buy-escrow.450a0407.png";